// extracted by mini-css-extract-plugin
export default {"inputContainer":"CheckboxInput_inputContainer__z92wJ","input":"CheckboxInput_input__xUVQo","inputLabel":"CheckboxInput_inputLabel__I43xc"};